import { Card } from "@/components/ui";
import { CalendarIcon, UserIcon } from "@/components/icons";
import { Button, Title } from "rizzui";
import dayjs from "dayjs";
import { IUserAdCredit } from "@/utilities/types/AdCredit";

interface PackageInfoCardProps {
  creditPerUser: IUserAdCredit;
}

export default function PackageInfoCard({
  creditPerUser,
}: PackageInfoCardProps) {
  return (
    <Card className="p-6 h-full">
      <div className="flex flex-col h-full">
        <Title as="h3" className="text-xl font-semibold mb-4">
          Package
        </Title>

        <div className="flex items-center mb-2">
          <UserIcon className="mr-2 h-5 w-5 text-gray-500" />
          <p className="font-medium">{creditPerUser.name}</p>
        </div>

        <div className="flex items-center mb-6">
          <CalendarIcon className="mr-2 h-5 w-5 text-gray-500" />
          <p>
            Valid Until{" "}
            <span className="font-bold">
              {creditPerUser.expiredAt
                ? dayjs(creditPerUser.expiredAt).format("DD MMMM YYYY")
                : "Unlimited"}
            </span>
          </p>
        </div>

        <div className="mt-auto">
          <Button
            size="lg"
            className="w-full bg-black text-white hover:bg-gray-800"
            onClick={() => window.open("https://wa.link/q3vcx9", "_blank")}
          >
            Upgrade Package
          </Button>
        </div>
      </div>
    </Card>
  );
}
